import { render } from "./RedeView.vue?vue&type=template&id=6ffbefb1&scoped=true"
import script from "./RedeView.vue?vue&type=script&lang=js"
export * from "./RedeView.vue?vue&type=script&lang=js"

import "./RedeView.vue?vue&type=style&index=0&id=6ffbefb1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ffbefb1"]])

export default __exports__